var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/useICE.ts
import * as React from "react";
var useICE = (iceKey, scriptSrc = void 0, autoDiscover = "silent") => {
  const [ice, setICE] = React.useState();
  const ICE_SCRIPT_PATH = "https://web.ipce.broadcom.com/ipce.1.1.1.min.js";
  React.useEffect(() => {
    if (!iceKey) {
      console.error("[ICE Error]: ICE Product key not provided");
    } else {
      window.IPCE_KEY = iceKey;
    }
  }, [iceKey]);
  const loadScript = React.useCallback(() => {
    const id = "ice_script";
    const src = scriptSrc != null ? scriptSrc : ICE_SCRIPT_PATH;
    const proxyHandler = {
      get(target, prop, receiver) {
        if (prop === "init") {
          return window._ipceInit;
        }
        return Reflect.get(target, prop, receiver);
      }
    };
    return new Promise((resolve, reject) => {
      if (window.IPCE && window._ipceInit) {
        resolve(new Proxy(window.IPCE, proxyHandler));
      } else {
        const existing = document.getElementById(id);
        const script = existing || document.createElement("script");
        script.addEventListener("error", reject);
        script.addEventListener("load", () => {
          const checkInit = (times = 6, delay = 250) => __async(void 0, null, function* () {
            if (window.IPCE) {
              if (autoDiscover !== "off") {
                yield window.IPCE.discover(autoDiscover === "silent");
              }
              resolve(new Proxy(window.IPCE, proxyHandler));
            } else {
              if (times > 0) {
                setTimeout(() => void checkInit(times - 1, delay * 2), delay);
              } else {
                reject();
              }
            }
          });
          void checkInit();
        });
        script.setAttribute("id", id);
        script.setAttribute("src", src);
        script.setAttribute("async", "");
        if (!existing) {
          document.head.appendChild(script);
        }
      }
    });
  }, [autoDiscover, scriptSrc]);
  const load = React.useCallback(() => __async(void 0, null, function* () {
    try {
      const _ice = yield loadScript();
      setICE(_ice);
    } catch (err) {
      console.error("[ICE Error]: Unable to load ICE", err);
    }
  }), [loadScript]);
  React.useEffect(() => {
    if (!ice) {
      void load();
    }
  }, [ice, load]);
  return ice;
};
export {
  useICE
};
